module.exports = function getResource(label) {
    let resources = {
        seeMore: 'See more',
        showMore: 'Show more'
    };
    return resources[label];
};
